import React, { useState } from 'react'
import { useCallback } from 'react';
import { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap'
import SweetAlert from 'react-bootstrap-sweetalert';

TableActionItems.defaultProps = {
  rowId: '',
  size: 'md',
  formRender: () => { },
  doDelete: () => { },
  addButtonRow: () => [],
  type: 'update',
  data: {},
  showCreate: false,
  showUpdate: false,
  showDelete: false,
}

export default function TableActionItems({
  rowId, size, formRender, type, doDelete, addButtonRow, data,
  showCreate, showUpdate, showDelete
}) {
  const [modalShow, setModalShow] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalClassName, setModalClassName] = useState('')
  const [showAlert, setShowAlert] = useState(false);
  const [processingAlert, setProcessingAlert] = useState(false);
  const [customForm, setCustomForm] = useState(false)
  const [form, setForm] = useState(<></>)
  const [buttons, setButtons] = useState([]);

  const modalHide = () => {
    setModalShow(false)
  }

  const handleGet = useCallback(async () => {
    setCustomForm(false);
    if (!rowId) {
      setModalTitle('Registrar')
      setModalShow(true);
      return
    }

    setModalTitle(`Modificar #${rowId}`)
    setModalShow(true);
  }, [rowId])

  useEffect(() => {
    const handleShowModalDelete = () => {
      setShowAlert(true);
    }

    const rowButtons = [];

    if (showUpdate) {
      rowButtons.push({
        variant: showUpdate?.color_action,
        icon: showUpdate?.icon_action,
        text: showUpdate?.name_action,
        onClick: handleGet,
        minWidth: 76
      })
    }

    if (showDelete) {
      rowButtons.push({
        variant: showDelete?.color_action,
        icon: showDelete?.icon_action,
        text: showDelete?.name_action,
        onClick: handleShowModalDelete,
        minWidth: 88
      })
    }

    const buttonsRow = addButtonRow({ setModalShow, modalHide, setModalTitle, setCustomForm, rowId, setForm, data, setModalClassName })

    setButtons([
      ...rowButtons,
      ...buttonsRow,
    ])
  }, [showUpdate, showDelete, handleGet, addButtonRow, rowId, data])


  return <>
    {type === 'create' && showCreate && <div className='mb-3'>
      <Button variant="primary" onClick={handleGet}>
        <i className='fa fa-plus me-2'></i>
        <span>Nuevo</span>
      </Button>
    </div>}

    {type === 'update' && <div className='d-flex justify-content-center buttons-actions'>
      {React.Children.toArray(buttons.map((button) => {
        return <div className='me-3'>
          <i className={`${button.icon} align-self-center cur-pointer icon-action text-${button.variant}`} onClick={button.onClick}></i>
        </div>
      }))}
    </div>}

    <Modal show={modalShow} onHide={modalHide} backdrop="static" size={size} className={modalClassName}>
      <Modal.Header closeButton>
        <Modal.Title as="div">{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {customForm ? form : formRender({
          modalHide
        })}
      </Modal.Body>
    </Modal>

    <SweetAlert
      show={showAlert}
      warning
      title=""
      onConfirm={() => { }}
      customButtons={<div className='mt-3'>
        <Button disabled={processingAlert} variant="danger me-4 text-white" onClick={() => {
          doDelete({
            setProcessingAlert,
            hideAlert: () => {
              setProcessingAlert(false);
              setShowAlert(false)
            }
          })
        }}>
          {processingAlert ? <i className="fa fa-circle-notch fa-spin"></i> : 'Si, eliminar'}
        </Button>
        <Button disabled={processingAlert} variant="outline-secondary" onClick={() => setShowAlert(false)}>
          No, cancelar
        </Button>
      </div>}
    >
      <h4>
        ¿Estás seguro de eliminar el registro #{rowId}?
      </h4>
      ¡No podrás recuperar la información!
    </SweetAlert>
  </>
}